import { get } from 'lodash'

export const genPreviewRefCode = (specialOfferDetail, refCodeFormat, marketList) => {
  const specialOfferStartDate = get(specialOfferDetail, 'general.startDate', '')
  const specialOfferEndDate = get(specialOfferDetail, 'general.endDate', '')
  const START_YY = (specialOfferStartDate === '') ? '-' : new Date(specialOfferStartDate).getFullYear().toString().substr(-2)
  const END_YY = (specialOfferEndDate === '') ? '-' : new Date(specialOfferEndDate).getFullYear().toString().substr(-2)

  const rateCodeDataList = get(specialOfferDetail, 'rateCodeList', [])
  let rateCodeList = rateCodeDataList.map((rateCodeItem) => {
    return rateCodeItem.code
  })
  rateCodeList = rateCodeList.sort((a, b) => {
    return (a < b) ? -1 : 1
  })
  const RATECODE = (rateCodeList.length > 0) ? rateCodeList.join('-') : '-'

  const isEnableAllotment = get(specialOfferDetail, 'promotion.isEnableAllotment', false)
  const ALLOT_TYPE = (isEnableAllotment) ? 'ALT' : 'NOALT'
  const HOTEL_CODE = get(specialOfferDetail, 'hotel.information.code', '-')
  const PROMOTION_CODE = get(specialOfferDetail, 'promotion.code', '-')

  const agentList = get(specialOfferDetail, 'agentList', [])
  const includedMarketList = marketList.filter(market => _isIncludeAgentInMarket(market, agentList))
  const marketNameList = includedMarketList.map(market => market.name)
  const MARKET = (marketNameList.length > 0) ? marketNameList.join('-') : '-'

  let tempRefCode = refCodeFormat.toUpperCase()
  tempRefCode = tempRefCode.replace(/\$\{START_YY\}/g, START_YY)
  tempRefCode = tempRefCode.replace(/\$\{END_YY\}/g, END_YY)
  tempRefCode = tempRefCode.replace(/\$\{RATECODE\}/g, RATECODE)
  tempRefCode = tempRefCode.replace(/\$\{HOTEL_CODE\}/g, HOTEL_CODE)
  tempRefCode = tempRefCode.replace(/\$\{PROMOTION_CODE\}/g, PROMOTION_CODE)
  tempRefCode = tempRefCode.replace(/\$\{MARKET\}/g, MARKET)
  tempRefCode = tempRefCode.replace(/\$\{ALLOT_TYPE\}/g, ALLOT_TYPE)

  return tempRefCode
}

const _isIncludeAgentInMarket = (market, agentList) => {
  const isIncludeAgent = agentList.some(agent => market.agentIdList.includes(agent.id))
  return isIncludeAgent
}

export const getSpecialOfferFileName = (refCode, prefix = 'special-offer-', extension = 'docx', refCodeMaxLength = 199) => {
  refCode = refCode.substr(0, refCodeMaxLength).replace(/\s+/g, '_').replace(/\//g, '_')
  const fileName = `${prefix}${refCode}.${extension}`

  return fileName
}

export const applyMessageTableStyle = (message) => {
  const appliedMessage = _applyTableStyle(message)

  return appliedMessage
}

const _applyTableStyle = (message) => {
  let appliedMessage = message.replace(/<table>/g, '<table style="margin: 0; border-collapse: collapse; border-spacing: 0; border: 1px double #b3b3b3;">')
  appliedMessage = appliedMessage.replace(/<th>/g, '<th style="font-weight: 700; background: #fafafa; min-width: 2em; padding: .4em; border: 1px solid #d9d9d9;">')
  appliedMessage = appliedMessage.replace(/<td>/g, '<td style="min-width: 2em; padding: .4em; border: 1px solid #d9d9d9;">')

  return appliedMessage
}
